import React from 'react';
import ReactDOM from 'react-dom';
import { MapModuleButton } from '../../MapModuleButton';
import { ToolbarButtonItem } from 'oskari-ui/components/buttons';
import { BackwardIcon, ForwardIcon, MeasureAreaIcon, MeasureLineIcon } from 'oskari-ui/components/icons';
import { MenuOutlined } from '@ant-design/icons';
import './request/ToolContainerRequest';
import './request/ToolContainerRequestHandler';

/**
 * @class Oskari.mapframework.bundle.mapmodule.plugin.PublisherToolbarPlugin
 * Provides publisher toolbar container
 */
Oskari.clazz.define('Oskari.mapframework.bundle.mapmodule.plugin.PublisherToolbarPlugin',
/**
 * @static @method create called automatically on construction
 *
 *
 */
function (conf) {
  var me = this;
  me._clazz = 'Oskari.mapframework.bundle.mapmodule.plugin.PublisherToolbarPlugin';
  me._defaultLocation = 'top left';
  me._index = 2;
  me._name = 'PublisherToolbarPlugin';
  me._toolButtons = conf.buttons || [];
}, {
  // templates for tools-mapplugin
  templates: {
    main: '<div class="mapplugin tools"></div>'
  },
  _createRequestHandlers: function _createRequestHandlers() {
    return {
      'Toolbar.ToolContainerRequest': Oskari.clazz.create('Oskari.mapframework.bundle.toolbar.request.ToolContainerRequestHandler', this)
    };
  },
  _handleMeasureTool: function _handleMeasureTool(tool, requestName) {
    if (this._isPublisherActive()) {
      return;
    }
    var sb = this.getSandbox();
    if (this.activeTool === 'measurearea' || this.activeTool === 'measureline') {
      sb.postRequestByName('DrawTools.StopDrawingRequest', ['mapmeasure', true]);
    }
    if (this.activeTool === tool) {
      var toolbarRequest = Oskari.requestBuilder('Toolbar.SelectToolButtonRequest')(null, 'PublisherToolbar-basictools');
      sb.request(this, toolbarRequest);
      this.activeTool = undefined;
      this.refresh();
      return;
    }
    var toolRequest = Oskari.requestBuilder('ToolSelectionRequest')(requestName);
    sb.request(this, toolRequest);
    this.activeTool = tool;
    this.refresh();
  },
  addToolButton: function addToolButton(name) {
    if (this._toolButtons.indexOf(name) < 0) {
      this._toolButtons.push(name);
    }
    this.refresh();
  },
  removeToolButton: function removeToolButton(name) {
    var index = this._toolButtons.indexOf(name);
    if (index > -1) {
      this._toolButtons.splice(index, 1);
    }
    this.refresh();
  },
  /**
   * @private @method _createControlElement
   */
  _createControlElement: function _createControlElement() {
    return jQuery(this.templates.main);
  },
  teardownUI: function teardownUI() {
    // remove old element
    this.removeFromPluginContainer(this.getElement());
  },
  /**
   * Handle plugin UI and change it when desktop / mobile mode
   * @method  @public createPluginUI
   * @param  {Boolean} mapInMobileMode is map in mobile mode
   * @param {Boolean} forced application has started and ui should be rendered with assets that are available
   */
  redrawUI: function redrawUI(mapInMobileMode, forced) {
    if (!this.isVisible()) {
      // no point in drawing the ui if we are not visible
      return;
    }
    var me = this;
    this.teardownUI();
    me._element = me._createControlElement();
    this.addToPluginContainer(me._element);
    this.refresh();
  },
  refresh: function refresh() {
    var el = this.getElement();
    if (!el) {
      return;
    }
    ReactDOM.render(/*#__PURE__*/React.createElement(MapModuleButton, {
      className: "t_publishertoolbar",
      icon: /*#__PURE__*/React.createElement(MenuOutlined, null),
      title: this._loc.title,
      withToolbar: true,
      position: this.getLocation()
    }, this.renderToolbarItems()), el[0]);
  },
  renderToolbarItems: function renderToolbarItems() {
    var _this = this;
    var buttons = [];
    this._toolButtons.forEach(function (button) {
      switch (button) {
        case 'history_back':
          buttons.push(/*#__PURE__*/React.createElement(ToolbarButtonItem, {
            key: "tool-back",
            icon: /*#__PURE__*/React.createElement(BackwardIcon, null),
            title: _this._loc.history.back,
            onClick: function onClick() {
              if (!_this._isPublisherActive()) {
                var reqBuilder = Oskari.requestBuilder('ToolSelectionRequest');
                _this.getSandbox().request(_this, reqBuilder('map_control_tool_prev'));
              }
            }
          }));
          break;
        case 'history_forward':
          buttons.push(/*#__PURE__*/React.createElement(ToolbarButtonItem, {
            key: "tool-next",
            icon: /*#__PURE__*/React.createElement(ForwardIcon, null),
            title: _this._loc.history.next,
            onClick: function onClick() {
              if (!_this._isPublisherActive()) {
                var reqBuilder = Oskari.requestBuilder('ToolSelectionRequest');
                _this.getSandbox().request(_this, reqBuilder('map_control_tool_next'));
              }
            }
          }));
          break;
        case 'measureline':
          buttons.push(/*#__PURE__*/React.createElement(ToolbarButtonItem, {
            key: "tool-line",
            icon: /*#__PURE__*/React.createElement(MeasureLineIcon, null),
            title: _this._loc.measure.line,
            onClick: function onClick() {
              var rn = 'map_control_measure_tool';
              var tool = 'measureline';
              _this._handleMeasureTool(tool, rn);
            },
            iconActive: _this.activeTool === 'measureline'
          }));
          break;
        case 'measurearea':
          buttons.push(/*#__PURE__*/React.createElement(ToolbarButtonItem, {
            key: "tool-area",
            icon: /*#__PURE__*/React.createElement(MeasureAreaIcon, null),
            title: _this._loc.measure.area,
            onClick: function onClick() {
              var rn = 'map_control_measure_area_tool';
              var tool = 'measurearea';
              _this._handleMeasureTool(tool, rn);
            },
            iconActive: _this.activeTool === 'measurearea'
          }));
          break;
        default:
          break;
      }
    });
    return buttons;
  },
  _isPublisherActive: function _isPublisherActive() {
    var publisherService = this.getSandbox().getService('Oskari.mapframework.bundle.publisher2.PublisherService');
    return publisherService && publisherService.getIsActive();
  },
  _stopPluginImpl: function _stopPluginImpl(sandbox) {
    this.teardownUI();
  }
}, {
  'extend': ['Oskari.mapping.mapmodule.plugin.BasicMapModulePlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  'protocol': ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});